import React, { Component } from "react";
// import page components
import Header from "./components/header";
import {TopSection} from "./components/top_section";
import SectionVideo from "./components/video_section";
import { EasyTesting } from "./components/easy_steps";
import { Accordeon } from "./components/accordeon";
// styles for page
import "./mainpage.css";

export default class MainPage extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="homepage">
        <Header />
        <TopSection/>
        <SectionVideo />
        <EasyTesting />
        <Accordeon />
        <div className="footer perfectCenter">
          2018 &#169; Testing is everything
        </div>
      </div>
    );
  }
}
